<ngb-accordion class="accordion-filter-by-letter" [animation]="true" [closeOthers]="true" activeIds="disease-letter">
    <ngb-panel title="Browse by Letter" id="disease-letter">
        <ng-template ngbPanelContent>
            <div class="letter-box">
                <div class="row letter-row" *ngFor="let letters of filterLetterRows">
                    <div *ngFor="let letter of letters" class="col-2 letter-bubble" [ngClass]="{ selected: activeLetter === letter }">
                        <button
                            type="button"
                            class="letter bg-transparent border-0 p-0 w-100 text-reset"
                            (click)="clickFilterLetter(letter)"
                            [attr.aria-label]="'Filter by letter ' + letter"
                            [attr.aria-pressed]="activeLetter === letter"
                        >
                            {{ letter }}
                        </button>
                    </div>
                </div>
            </div>
        </ng-template>
    </ngb-panel>
</ngb-accordion>
